import { styled } from '@material-ui/core/styles';
import { container } from 'UI/constants/dimensions';
import { getDarkBarShadow } from 'UI/constants/styles';
import { isDarkTheme } from 'UI/theme/darkTones';

export const ChatContainer = styled('div')({
  flexGrow: 1,
  overflowY: 'auto',
  position: 'relative'
});

export const MessageComposerContainer = styled('div')(({ theme }) => ({
  boxShadow: container.boxShadow,
  position: 'sticky',
  bottom: 0,
  ...(isDarkTheme(theme) && {
    backgroundColor: theme.palette.background.paper,
    boxShadow: getDarkBarShadow('up')
  })
}));
